/**
 * 故障台账管理路由配置
 */
const faultRoute = {
  path: 'fault',
  name: 'fault',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'faultList',
      component: () => import('./index.vue'),
      meta: {
        navtabTitle: '故障台账管理',
        isCache: true,
        ignoreDiff: [],
        isIframe: false
      }
    }
  ]
};

export default faultRoute;
